import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../api/Authcontext'
import './Login.css'
import logo from '../assets/logo.png'
import { FiEye,FiEyeOff } from "react-icons/fi";

const Login = () => {
  const navigate = useNavigate();
  const { login, isAuthenticated, userData, isInitialized } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Redirect if already authenticated
  useEffect(() => {
    if (isInitialized && isAuthenticated() && userData) {
      navigate('/home');
    }
  }, [isInitialized, isAuthenticated, userData, navigate]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await login(formData.email, formData.password);
      navigate('/home');
    } catch (err) {
      setError(err.message);
      console.error('Login error:', err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className='login-container'>

        <div className='welcome-container'>
            <img src={logo} alt="Logo" className="logo-image" className='logo-image'/>
            <div className='welcome-text'>
                <span>Welcome to</span>
                <span>Renjit Welfare</span>
                <span>Association</span>
                <span>Online</span>
            </div>
        </div>

        <form className='login-form' onSubmit={handleLogin}>
          <div>
            <h3>Sign In</h3>
            <p>Sign in to continue. Remember, your password is yours, do not share it with anyone.</p>
          </div>
          {error && <div style={{color: 'red', marginBottom: '10px'}}>{error}</div>}
          <div>
            <div className="input-container">
              <label htmlFor="email">Email</label>
              <input 
                type="email"
                className="form-input"
                id="email" 
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Enter your email" 
                required
              />
            </div>
            <div className="input-container">
              <label htmlFor="password">Password</label>
              <div style={{ position: 'relative' }}>
                <input 
                  type={showPassword ? "text" : "password"}
                  className="form-input"
                  id="password" 
                  name="password"
                  value={formData.password}
                  onChange={handleInputChange}
                  placeholder="Enter your password" 
                  required
                  style={{ paddingRight: '50px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '15px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#666',
                    fontSize: '18px',
                    padding: '0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                  title={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <FiEyeOff /> : <FiEye />}
                </button>
              </div>
            </div>
          </div>

          <p className='forgot-password-text' onClick={() => navigate('/forgot-password')}>Forgot Password?</p>
          <button type="submit" className="login-form-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

    </div>
  )
}

export default Login